import { Guid } from '@fitscovery/common/types';
import { BookingData, PartnerBooking } from '../models';

export namespace BookingActions {
  
  export class GetPartnerBooking {
    static readonly type = '[Booking] GetPartnerBooking';
    constructor(public partnerId: Guid) { }
  }
  
  export class GetUpcomingBookings {
    static readonly type = '[Booking] GetUpcomingBookings';
    constructor(public partnerId: Guid) { }
  }
  
  export class UpdatePartnerBooking {
    static readonly type = '[Booking] UpdatePartnerBooking';
    constructor(public bookingDetails: PartnerBooking) { }
  }
  
  export class UpdateMemberBooking {
    static readonly type = '[Booking] UpdateMemberBooking';
    constructor(public bookingData: BookingData) { }
  }

}
